export interface CloudinaryTransformOptions {
  width: number
  aspectRatio: number
}

export const transformCloudinaryImageUrl = (
  originalUrl: string,
  options: CloudinaryTransformOptions
): string => {
  if (!originalUrl || typeof originalUrl !== 'string') {
    return originalUrl || ''
  }

  if (!options.width || options.width <= 0) {
    return originalUrl
  }

  if (!options.aspectRatio || options.aspectRatio <= 0) {
    return originalUrl
  }

  try {
    const urlParts = originalUrl.split('?')
    const baseUrlWithPath = urlParts[0]
    const queryParams = urlParts[1] ? `?${urlParts[1]}` : ''

    if (!baseUrlWithPath) {
      return originalUrl
    }

    if (!baseUrlWithPath.includes('cloudinary') || !baseUrlWithPath.includes('/images/')) {
      return originalUrl
    }

    const imagesIndex = baseUrlWithPath.indexOf('/images/')
    const baseUrl = baseUrlWithPath.substring(0, imagesIndex + '/images/'.length)
    const remainingPath = baseUrlWithPath.substring(imagesIndex + '/images/'.length)

    const pathSegments = remainingPath.split('/')
    let assetPathStartIndex = 0

    for (let i = 0; i < pathSegments.length; i++) {
      const segment = pathSegments[i]
      if (segment && (!segment.includes('_') || segment.startsWith('legacy_dam'))) {
        assetPathStartIndex = i
        break
      }
    }

    const assetPath = pathSegments.slice(assetPathStartIndex).join('/')

    const { width, aspectRatio } = options
    const newTransformation = `c_fill,g_center,dpr_auto,f_auto,w_${width},ar_${aspectRatio}`

    const transformedUrl = `${baseUrl}${newTransformation}/${assetPath}${queryParams}`

    return transformedUrl
  } catch (error) {
    return originalUrl
  }
}

export const transformStockOptionHeroImage = (originalUrl: string, width: number = 600): string => {
  return transformCloudinaryImageUrl(originalUrl, {
    width,
    aspectRatio: 1.6
  })
}

export const transformStockOptionTabImage = (originalUrl: string, width: number = 200): string => {
  return transformCloudinaryImageUrl(originalUrl, {
    width,
    aspectRatio: 1.6
  })
}
